module.exports = {
  "step-body": {
    "flexDirection": "column",
    "justifyContent": "center",
    "alignItems": "stretch",
    "overflow": "hidden"
  },
  "step-flow-wrapper": {
    "position": "absolute",
    "left": 0,
    "right": 0,
    "top": 0,
    "height": "16",
    "flexDirection": "row",
    "justifyContent": "flex-start",
    "alignItems": "center",
    "overflow": "hidden"
  },
  "step-line": {
    "width": "0",
    "height": "2",
    "borderTopColor": "#e5e5e8",
    "borderTopWidth": "2",
    "borderTopStyle": "solid",
    "marginLeft": "8",
    "marginRight": "8"
  },
  "hline": {
    "borderTopWidth": "4"
  },
  "step-item-wrapper": {
    "flexDirection": "row",
    "justifyContent": "space-between",
    "alignItems": "flex-start"
  },
  "step-item": {
    "flexDirection": "column",
    "justifyContent": "flex-start",
    "alignItems": "center",
    "overflow": "hidden",
    "wordWrap": "break-word",
    "wordBreak": "break-all",
    "paddingLeft": "8",
    "paddingRight": "8"
  },
  "step-point": {
    "width": "16",
    "height": "16",
    "backgroundColor": "#c7c7cc",
    "borderRadius": "32"
  },
  "step-desc": {
    "paddingTop": "20",
    "fontFamily": "PingFangSC-Regular",
    "fontSize": "26",
    "color": "#8E969B",
    "textAlign": "center"
  },
  "active-step": {
    "color": "#1E2E37"
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-6f217df2!./~/weex-vue-loader/lib/selector.js?type=styles&index=0!./packages/dof-step-flow-h/index.vue
// module id = 511
// module chunks = 0 1